import rest from "@/rest-client";
import Vue from "vue";

const app = new Vue();
export default {
  moduleName: "user",
  namespaced: true,
  persistent: ["account", "jwt", "jwtExpiresAt", "refreshTokenExpiresAt", "deviceId", "isAdminOrOwnerOfAnyWorkpace", "accessableRoles"],
  state: () => ({
    account: undefined,
    jwt: undefined,
    jwtExpiresAt: undefined,
    refreshTokenExpiresAt: undefined,
    isUpdating: false,
    isAdminOrOwnerOfAnyWorkpace: false,
    accessableRoles: [],
    deviceId: undefined,
  }),
  getters: {
    jwt(state) {
      return state.jwt;
    },
    account(state) {
      return state.account;
    },
    deviceId: (state) => state.deviceId,
    jwtExpiresAt: (state) => state.jwtExpiresAt,
    refreshTokenExpiresAt: (state) => state.refreshTokenExpiresAt,
    isUpdating: (state) => state.isUpdating,
    isAdminOrOwnerOfAnyWorkpace: (state) => state.isAdminOrOwnerOfAnyWorkpace,
    accessableRoles: (state) => state.accessableRoles,
  },

  mutations: {
    auth(state, response) {
      state.account = response.account;
      state.jwt = response.token;
      state.jwtExpiresAt = response.expiresIn ? Date.now() + response.expiresIn * 1000 : undefined;
      state.refreshTokenExpiresAt = response.refreshTokenExpiresIn ? Date.now() + response.refreshTokenExpiresIn * 1000 : undefined;
      state.deviceId = response.deviceId ?? state.deviceId;
    },
    account(state, account) {
      state.account = account;
    },
    setLanguage(state, language) {
      state.account.language = language;
    },
    isUpdating: (state, value) => (state.isUpdating = value),
    isAdminOrOwnerOfAnyWorkpace: (state, value) => (state.isAdminOrOwnerOfAnyWorkpace = value),
    accessableRoles: (state, value) => (state.accessableRoles = value),
    reset(state) {
      state.account = undefined;
      state.jwt = undefined;
      state.jwtExpiresAt = undefined;
      state.refreshTokenExpiresAt = undefined;
      state.isUpdating = false;
      state.isAdminOrOwnerOfAnyWorkpace = false;
      state.accessableRoles = [];
      state.deviceId = undefined;
    },
  },

  actions: {
    async login({ commit }, credential) {
      const { data } = await rest.post("/login", credential);
      commit("auth", data);

      return data;
    },
    async refreshToken({ commit, state }) {
      if (!state.deviceId) {
        throw new Error("No deviceId available for refresh");
      }

      const { data } = await rest.post("/refresh-token", { deviceId: state.deviceId });
      commit("auth", data);
      return data;
    },
    async logOut({ commit }, message) {
      try {
        await rest.post("/logout", {}, { abortOnPageChange: false });
      } catch (error) {}
      if (message) {
        app.$toast.warning(message);
      }
      setTimeout(() => {
        commit("organization/reset", null, { root: true });
        commit("switchWorkspace/reset", null, { root: true });
        commit("layout/reset", null, { root: true });

        commit("reset");
        window.location.href = "/login";
      }, 2000);
    },

    async register({ commit }, payload) {
      const response = await rest.post("/account", payload);
    },

    async updateProfile({ commit, state }, payload) {
      commit("isUpdating", true);
      try {
        let lang = state.account.language;
        const response = await rest.put("/account", payload);
        commit("account", response.data);

        if (lang != payload.language) {
          setTimeout(() => {
            location.reload();
          }, 700);
        }
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async refreshAccount({ commit }) {
      try {
        const { data } = await rest.get("/account");
        commit("account", data);
        return data;
      } catch (error) {}
    },

    async resetPassword({ commit }, payload) {
      const response = await rest.post("/account/token", payload);
      return response;
    },
    async changePassword({ commit }, payload) {
      const response = await rest.post("/account/password", payload);
      return response;
    },

    async activate({ commit }, payload) {
      return rest.post("/account/activate", payload);
    },

    async delete({ commit }, payload) {
      return rest.post(`account/delete`, payload);
    },
  },
};
